/** Opens what an assistant message points to (from the notifications, and from links in emails and Telegram). */
import { openNote, openPaper, openSettings, openView } from "@/lib/store";

export interface AssistantLink {
  type: "note" | "paper" | "task" | "manuscript" | "library" | "code_data" | "correspondence" | "knowledge" | "assistant" | "invite" | "learning";
  id?: string;
  workspaceId?: string;
  title?: string;
  /** The part of the page to show (a manuscript's "review" tab). */
  tab?: string;
}

export function openLink(l: AssistantLink | null | undefined) {
  if (!l) return;
  const ws = l.workspaceId;
  switch (l.type) {
    case "note":
      return l.id && openNote(l.id, l.title ?? "Note", ws);
    case "paper":
      return l.id && openPaper(l.id, l.title ?? "Paper", undefined, ws);
    case "task":
      return openView("backlog", ws, "Backlog", l.id ? { task: l.id } : undefined);
    case "manuscript":
      return l.id && openView("manuscript", ws, l.title ?? "Manuscript", l.tab ? { tab: l.tab, at: String(Date.now()) } : undefined, l.id);
    case "library":
      return openView("library", ws, "Library");
    case "code_data":
      return openView("code_data", ws, "Code and data");
    case "correspondence":
      return openView("correspondence", ws, "Correspondence", l.id ? { thread: l.id } : undefined);
    case "knowledge":
      return openView("knowledge", ws, "Knowledge base");
    case "assistant":
      return openSettings({ tab: "assistant" });
    case "learning":
      return l.id && openView("learning", ws, l.title ?? "Learning", undefined, l.id);
    case "invite":
      return openSettings({ section: "invite" });
  }
}

/** A link from an email or Telegram (/open?type=…&id=…&ws=…): opened once the app is there. */
export function openFromUrl() {
  if (window.location.pathname !== "/open") return;
  const q = new URLSearchParams(window.location.search);
  window.history.replaceState(null, "", "/");
  const type = q.get("type") as AssistantLink["type"] | null;
  if (type) queueMicrotask(() => openLink({ type, id: q.get("id") ?? undefined, workspaceId: q.get("ws") ?? undefined, title: q.get("title") ?? undefined, tab: q.get("tab") ?? undefined }));
}
